import { neutral } from '@bloomfieldrobotics/canopy';
import { styled, TableCell, TableCellProps } from '@mui/material';

export const SettingsHeaderCell = styled(TableCell)<TableCellProps>(
  ({ theme }) => ({
    borderBottom: '0.5px solid',
    borderTop: '0.5px solid',
    borderColor: neutral[800],
    padding: theme.spacing(2),
    height: '2rem',
    color: theme.vars.palette.text.secondary,
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: '166%',
  })
);
